/**
 * postMessage types between chatbot iframe ↔ seller host.
 * Keep values in sync with seller-v-2 `src/constants/postMessage.ts`.
 */
export enum PostMessageType {
  // Auth / session
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  USER_INFO = 'USER_INFO',

  // Chatbot panel
  CHAT_TOGGLE = 'CHAT_TOGGLE',
  CHAT_COMMAND_SUBMENU = 'CHAT_COMMAND_SUBMENU',

  // Navigation
  NAVIGATE_TO = 'NAVIGATE_TO',
  NAVIGATE_ROUTE = 'NAVIGATE_ROUTE',

  // Tendoo AI display
  CONFIG_TENDO_AI = 'CONFIG_TENDO_AI',
  HIDE_TENDO_CHATBOT = 'HIDE_TENDO_CHATBOT',

  // Conversation dialogs
  CHAT_CONVERSATION_RENAME_REQUEST = 'CHAT_CONVERSATION_RENAME_REQUEST',
  CHAT_CONVERSATION_RENAME_RESULT = 'CHAT_CONVERSATION_RENAME_RESULT',
  CHAT_CONVERSATION_RENAME_SUCCESS = 'CHAT_CONVERSATION_RENAME_SUCCESS',
  CHAT_CONVERSATION_DELETE_REQUEST = 'CHAT_CONVERSATION_DELETE_REQUEST',
  CHAT_CONVERSATION_DELETE_RESULT = 'CHAT_CONVERSATION_DELETE_RESULT',
  CHAT_CONVERSATION_DELETE_SUCCESS = 'CHAT_CONVERSATION_DELETE_SUCCESS',

  // Attachments
  CHANGE_ATTACHMENT = 'CHANGE_ATTACHMENT',
  CHANGE_ATTACHMENT_RESULT = 'CHANGE_ATTACHMENT_RESULT',

  // Media / tips / cart
  CHATBOT_IMAGE_GALLERY = 'CHATBOT_IMAGE_GALLERY',
  CHATBOT_TIP_BUBBLE = 'CHATBOT_TIP_BUBBLE',
  CHATBOT_TIP_ACTION = 'CHATBOT_TIP_ACTION',
  SYNC_PRODUCTS_TO_CART = 'SYNC_PRODUCTS_TO_CART',

  // Voice: dialog micro hiển thị ở web cha (không bị cắt trong iframe)
  CHATBOT_MIC_DIALOG_REQUEST = 'CHATBOT_MIC_DIALOG_REQUEST',
  CHATBOT_MIC_DIALOG_RESULT = 'CHATBOT_MIC_DIALOG_RESULT',
}
